import React from 'react'
import PropTypes from 'prop-types'

export default class TrainPositionsHeader extends React.Component {
  static propTypes = {
    update_date: PropTypes.string,
    update_time: PropTypes.string,
  }

  static contextTypes = {
    intl: PropTypes.object
  }

  render() {
    const {update_date, update_time, notifications } = this.props
    var delay_info = notifications.some(notification => notification.delay === true)

    return (
      <div className="d-TrainPosition-DateTime">
        <i className={`d-TrainPosition-getState ${delay_info ? "is_error" : ""}`}></i>
        <p className={`d-TrainPosition-getDateTime ${delay_info ? "is_error" : ""}`}>
          <span className="d-TrainPosition-getDate">{update_date}</span>
          <span className="d-TrainPosition-getDate"> {update_time}</span>
          更新
        </p>
      </div>
    )
  }
}
